import "./App.css";
import Header from "./header";
import Profile from "./profile";
import About from "./about";
import Services from  "./services"
import Contact from "./contact";
import Work from "./work";
function App() {
  return (
    <div>
      <Header />
      <Profile />
      <About />
      <Work />
      <Services />
      <Contact />
    </div>
  );
}

export default App;
